/* tslint:disable */

/**
 * Type of the section point:
 *   * CARRIER
 *   * TANK
 *   * TERMINAL
 */
type SectionPointType =
  'CARRIER' |
  'TANK' |
  'TERMINAL';
namespace SectionPointType {
  export const CARRIER: SectionPointType = 'CARRIER';
  export const TANK: SectionPointType = 'TANK';
  export const TERMINAL: SectionPointType = 'TERMINAL';
  export function values(): SectionPointType[] {
    return [
      CARRIER,
      TANK,
      TERMINAL
    ];
  }
}

export { SectionPointType }